<it-card teaser="true" shadow="true" *ngIf="request">
  <div class="row" *ngIf="request.patient">
    <div class="col-3 mb-2">
      <div><strong>Nome paziente:</strong></div>
      <div>{{request.patient.name}} {{request.patient.surname}}</div>
    </div>
    <div class="col-3 mb-2">
      <div><strong>Codice Fiscale:</strong></div>
      <div>{{request.patient.fiscalCode}}</div>
    </div>
    <div class="col-3 mb-2">
      <div><strong>Luogo e data di Nascita:</strong></div>
      <div>{{request.patient.birthTown}} - {{request.patient.birthDate | date:'dd/MM/yyyy'}}</div>
    </div>
    <div class="col-3 mb-2">
      <div><strong>Residenza:</strong></div>
      <div>{{request.patient.residentialAddress}} {{request.patient.residentialTown}}</div>
    </div>
  </div>

  <div class="row" *ngIf="request.setting">
    <div class="col-3 mb-2">
      
        <strong>Setting:</strong>
      
      <div>
        {{ request.setting.name }}
        <span *ngIf="request.setting.subSettings[0]">
          {{ request.setting.subSettings[0].name }}
        </span>
      </div>
    </div>
    <div class="col-3 mb-2" *ngIf="request?.creator">
      <div><strong>Entità segnalante:</strong></div>
      <div>{{ request.creator?.name }}</div>
    </div>
    <div class="col-3 mb-2" *ngIf="request?.ownership">
      <div><strong>In carico a:</strong></div>
      <div>{{ request.ownership?.name }}</div>
    </div>

    <div class="col-3 mb-2" *ngIf="request?.facility">
      <div><strong>Struttura destinazione:</strong></div>
      <div>{{ request.facility?.name }}</div>
    </div>

    <!-- <div class="col-md-2 mb-2" *ngIf="request?.dischargeDate">
      <div><strong>Data di dimissione:</strong></div>
      <div>{{ request.dischargeDate | date:'dd/MM/YYYY' }}</div>
    </div> -->
  </div>

</it-card>
